import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type DoctorsInput = {}
export type DoctorsFilters = {}

export type DoctorsAvailableInput = {}

export type ClinicsInput = {}
export type ClinicsFilters = {}

export type AppointmentTypesInput = {}
export type AppointmentTypesFilters = {}

export type ServiceTypesInput = {}
export type ServiceTypesFilters = {}

export type CalendarInput = {}
export type CalendarFilters = {}

export type PatientInput = {}
export type PatientFilters = {}

export type UserInput = {}
export type UserFilters = {}

export type ReferralRulesInput = {}
export type ReferralRulesFilters = {}

export type ScriptRulesInput = {}
export type ScriptRulesFilters = {}

export type RequestConsultInput = {}
export type RequestConsultFilters = {}

export type CancelConsultInput = {}
export type CancelConsultFilters = {}

export type CreateUserInput = {}
export type CreateUserFilters = {}

export type AppointmentSlotsInput = {}
export type AppointmentSlotsFilters = {}

export type DeleteUserInput = {}
export type DeleteUserFilters = {}

export type RemoveClinicInput = {}
export type RemoveClinicFilters = {}

export type UpdateUserConfirmInput = {}
export type UpdateUserConfirmFilters = {}

export type SendVerificationEmailInput = {}
export type SendVerificationEmailFilters = {}

export type UpcomingAppointmentsInput = {}
export type UpcomingAppointmentsFilters = {}

export type RegisteredClinicsInput = {}
export type RegisteredClinicsFilters = {}

export type BannedPatientsInput = {}

export type UpdateUserInput = {}
export type UpdateUserFilters = {}

export type RegisterUserToClinicInput = {}
export type RegisterUserToClinicFilters = {}

export type RemoveClinicFromUserInput = {}
export type RemoveFamilyMemberFromUserInput = {}
export type AddFamilyMemberToUserInput = {}
export type RegisterFamilyMemberToClinicInput = {}
export type SendFamilyMemberVerificationInput = {}
export type CreateScriptInput = {}
export type CreateReferralInput = {}
export type CheckInInput = {}
export type VerifyEmailInput = {}
export type SendAppFeedbackInput = {}

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }

const defaultOptions = {} as const;
export type ClinicFragment = {
  __typename?: 'Clinic';
  clinic_group_crm?: string | null;
  user_fk?: string | null;
  location_id?: string | null;
  centre_name?: string | null;
  location_display_name?: string | null;
  is_default_location?: string | null;
  address?: string | null;
  suburb?: string | null;
  state?: string | null;
  postcode?: string | null;
  location_phone?: string | null;
  location_email?: string | null;
  contact_person_fName?: string | null;
  contact_person_lName?: string | null;
  clinic_group?: string | null;
  pms?: string | null;
  future_appt_wks?: string | null;
  lat?: string | null;
  lng?: string | null;
  website?: string | null;
  google_review_url?: string | null;
  kiosk_serial_no?: string | null;
  clinic_notice?: string | null;
  confirm_app_info?: string | null;
  confirm_app_holiday_info?: string | null;
  icon?: string | null;
  mon_start_time?: string | null;
  mon_end_time?: string | null;
  tue_start_time?: string | null;
  tue_end_time?: string | null;
  wed_start_time?: string | null;
  wed_end_time?: string | null;
  thu_start_time?: string | null;
  thu_end_time?: string | null;
  fri_start_time?: string | null;
  fri_end_time?: string | null;
  sat_start_time?: string | null;
  sat_end_time?: string | null;
  sun_start_time?: string | null;
  sun_end_time?: string | null;
  ph_start_time?: string | null;
  ph_end_time?: string | null;
};

export type DoctorFragment = {
  __typename?: 'Doctor';
  clinic_group_crm?: string | null;
  user_fk?: string | null;
  doctor_id?: string | null;
  location_id?: string | null;
  display_name?: string | null;
  gender?: string | null;
  about?: string | null;
  appt_types?: any | null;
  appt_types_duration?: any | null;
  is_nurse_or_doc?: string | null;
  sort_order?: string | null;
  allow_online_app?: string | null;
  allow_walk_ins?: string | null;
  room_no?: string | null;
  no_new_patients?: string | null;
  my_patients?: string | null;
  display_only?: string | null;
  allow_scripts?: string | null;
  allow_referrals?: string | null;
  enable_doc_notice?: string | null;
  doc_notice?: string | null;
  in_isolation?: string | null;
  iso_date?: string | null;
  location_display_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  image?: string | null;
};

export type AppointmentTypeFragment = {
  __typename?: 'AppointmentType';
  clinic_group_crm?: string | null;
  user_fk?: string | null;
  location_id?: string | null;
  service_type_id?: string | null;
  appointment_type_id?: string | null;
  display_name?: string | null;
  standard_duration?: string | null;
  is_face_to_face?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  nurse_required?: string | null;
  is_default?: string | null;
  cancellation_period?: string | null;
  question_required?: string | null;
  continue_or_no?: string | null;
  appt_que?: string | null;
  appt_inst?: string | null;
  new_patient?: string | null;
  week_days_only?: string | null;
  week_end_only?: string | null;
  pre_payment_req?: string | null;
  pre_payment_fees?: string | null;
  pre_payment_msg?: string | null;
  pre_payment_cnfrm_msg?: string | null;
  post_payment_req?: string | null;
  post_billing_type?: string | null;
  post_billing_fees?: string | null;
  post_billing_msg?: string | null;
  post_billing_cnfrm_msg?: string | null;
  consent_enabled?: string | null;
  consent_id?: string | null;
  low_age_min?: string | null;
  low_age_max?: string | null;
  upper_age_min?: string | null;
  upper_age_max?: string | null;
  last_f2f_visit_months?: string | null;
};

export type ServiceTypeFragment = {
  __typename?: 'ServiceType';
  id?: string | null;
  name?: string | null;
};

export type DoctorsAvailableFragment = {
  __typename?: 'DoctorsAvailable';
  doctor_id?: string | null;
  first_slot?: {
    __typename?: 'Firstslot';
    date?: string | null;
    time?: string | null;
    duration?: string | null;
  } | null;
};

export type BannedPatientsFragment = {
  __typename?: 'BannedPatients';
  banned_level?: string | null;
  banned_msg?: string | null;
};

export type AppointmentFragment = {
  __typename?: 'Appointment';
  date?: string | null;
  time?: string | null;
  duration?: string | null;
};

export type AppointmentSlotFragment = {
  __typename?: 'AppointmentSlot';
  date?: string | null;
  appointments?: Array<{
    __typename?: 'Appointment';
    date?: string | null;
    time?: string | null;
    duration?: string | null;
  } | null> | null;
};

export type CalendarFragment = {
  __typename?: 'Calendar';
  calendar?: Array<string | null> | null;
  first_available?: {
    __typename?: 'Appointment';
    date?: string | null;
    time?: string | null;
    duration?: string | null;
  } | null;
};

export type UserFragment = {
  __typename?: 'User';
  username?: any | null;
  phone_number?: string | null;
  email?: string | null;
  email_verified?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  dob?: string | null;
  gender?: string | null;
  created_at?: any | null;
  updated_at?: any | null;
  automed?: any | null;
  family_members?: any | null;
};

export type PatientFragment = {
  __typename?: 'Patient';
  patient_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  gender?: string | null;
  contact_number?: string | null;
  is_new_pt?: string | null;
  last_seen_did?: string | null;
};

export type UpcomingAppointmentFragment = {
  __typename?: 'UpcomingAppointment';
  patient_id?: string | null;
  is_new_pt?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  dob?: string | null;
  phone_number?: string | null;
  gender?: string | null;
  clinic_group_crm?: string | null;
  user_fk?: string | null;
  location_id?: string | null;
  doctor_id?: string | null;
  date?: string | null;
  time?: string | null;
  account_type?: string | null;
  appointment_id?: string | null;
  appointment_type_name?: string | null;
  appointment_type_id?: string | null;
  appointment_code?: string | null;
  cancellation_period?: string | null;
  doctor_full_name?: string | null;
  location_display_name?: string | null;
  address?: string | null;
  suburb?: string | null;
  state?: string | null;
  postcode?: string | null;
  location_phone?: string | null;
  lat?: string | null;
  lng?: string | null;
  image?: string | null;
};

export type ScriptRulesFragment = {
  __typename?: 'ScriptRules';
  enable_scripts?: string | null;
  script_payment_req?: string | null;
  script_msg?: string | null;
  script_confirm_msg?: string | null;
  script_apprv_msg?: string | null;
  script_decl_msg?: string | null;
  script_comp_msg?: string | null;
  scripts_mobile?: string | null;
  script_delivery_mthds?: Array<{
    __typename?: 'ScriptDeliveryMethods';
    enabled?: string | null;
    pms_schedule_id?: string | null;
    pms_desc_id?: string | null;
    fee?: string | null;
    delivery_desc?: string | null;
  } | null> | null;
};

export type ReferralRulesFragment = {
  __typename?: 'ReferralRules';
  enable_referrals?: string | null;
  referral_payment_req?: string | null;
  referral_msg?: string | null;
  referral_confirm_msg?: string | null;
  referral_apprv_msg?: string | null;
  referral_decl_msg?: string | null;
  referral_comp_msg?: string | null;
  referrals_mobile?: string | null;
  referral_delivery_mthds?: Array<{
    __typename?: 'ReferralDeliveryMethods';
    enabled?: string | null;
    pms_schedule_id?: string | null;
    pms_desc_id?: string | null;
    fee?: string | null;
    delivery_desc?: string | null;
  } | null> | null;
};

export type ClinicsQueryVariables = Exact<{
  input: ClinicsInput;
  filters?: InputMaybe<ClinicsFilters>;
}>;

export type ClinicsQuery = {
  __typename?: 'Query';
  clinics?: Array<{
    __typename?: 'Clinic';
    clinic_group_crm?: string | null;
    user_fk?: string | null;
    location_id?: string | null;
    centre_name?: string | null;
    location_display_name?: string | null;
    is_default_location?: string | null;
    address?: string | null;
    suburb?: string | null;
    state?: string | null;
    postcode?: string | null;
    location_phone?: string | null;
    location_email?: string | null;
    contact_person_fName?: string | null;
    contact_person_lName?: string | null;
    clinic_group?: string | null;
    pms?: string | null;
    future_appt_wks?: string | null;
    lat?: string | null;
    lng?: string | null;
    website?: string | null;
    google_review_url?: string | null;
    kiosk_serial_no?: string | null;
    clinic_notice?: string | null;
    confirm_app_info?: string | null;
    confirm_app_holiday_info?: string | null;
    icon?: string | null;
    mon_start_time?: string | null;
    mon_end_time?: string | null;
    tue_start_time?: string | null;
    tue_end_time?: string | null;
    wed_start_time?: string | null;
    wed_end_time?: string | null;
    thu_start_time?: string | null;
    thu_end_time?: string | null;
    fri_start_time?: string | null;
    fri_end_time?: string | null;
    sat_start_time?: string | null;
    sat_end_time?: string | null;
    sun_start_time?: string | null;
    sun_end_time?: string | null;
    ph_start_time?: string | null;
    ph_end_time?: string | null;
  } | null> | null;
};

export type DoctorsQueryVariables = Exact<{
  input: DoctorsInput;
  filters?: InputMaybe<DoctorsFilters>;
}>;

export type DoctorsQuery = {
  __typename?: 'Query';
  doctors?: Array<{
    __typename?: 'Doctor';
    clinic_group_crm?: string | null;
    user_fk?: string | null;
    doctor_id?: string | null;
    location_id?: string | null;
    display_name?: string | null;
    gender?: string | null;
    about?: string | null;
    appt_types?: any | null;
    appt_types_duration?: any | null;
    is_nurse_or_doc?: string | null;
    sort_order?: string | null;
    allow_online_app?: string | null;
    allow_walk_ins?: string | null;
    room_no?: string | null;
    no_new_patients?: string | null;
    my_patients?: string | null;
    display_only?: string | null;
    allow_scripts?: string | null;
    allow_referrals?: string | null;
    enable_doc_notice?: string | null;
    doc_notice?: string | null;
    in_isolation?: string | null;
    iso_date?: string | null;
    location_display_name?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    image?: string | null;
  } | null> | null;
};

export type DoctorsAvailableQueryVariables = Exact<{
  input: DoctorsAvailableInput;
}>;

export type DoctorsAvailableQuery = {
  __typename?: 'Query';
  doctorsAvailable?: Array<{
    __typename?: 'DoctorsAvailable';
    doctor_id?: string | null;
    first_slot?: {
      __typename?: 'Firstslot';
      date?: string | null;
      time?: string | null;
      duration?: string | null;
    } | null;
  } | null> | null;
};

export type BannedPatientsQueryVariables = Exact<{
  input: BannedPatientsInput;
}>;

export type BannedPatientsQuery = {
  __typename?: 'Query';
  bannedPatients?: {
    __typename?: 'BannedPatients';
    banned_level?: string | null;
    banned_msg?: string | null;
  } | null;
};

export type AppointmentTypesQueryVariables = Exact<{
  input: AppointmentTypesInput;
  filters?: InputMaybe<AppointmentTypesFilters>;
}>;

export type AppointmentTypesQuery = {
  __typename?: 'Query';
  appointmentTypes?: Array<{
    __typename?: 'AppointmentType';
    clinic_group_crm?: string | null;
    user_fk?: string | null;
    location_id?: string | null;
    service_type_id?: string | null;
    appointment_type_id?: string | null;
    display_name?: string | null;
    standard_duration?: string | null;
    is_face_to_face?: string | null;
    start_time?: string | null;
    end_time?: string | null;
    nurse_required?: string | null;
    is_default?: string | null;
    cancellation_period?: string | null;
    question_required?: string | null;
    continue_or_no?: string | null;
    appt_que?: string | null;
    appt_inst?: string | null;
    new_patient?: string | null;
    week_days_only?: string | null;
    week_end_only?: string | null;
    pre_payment_req?: string | null;
    pre_payment_fees?: string | null;
    pre_payment_msg?: string | null;
    pre_payment_cnfrm_msg?: string | null;
    post_payment_req?: string | null;
    post_billing_type?: string | null;
    post_billing_fees?: string | null;
    post_billing_msg?: string | null;
    post_billing_cnfrm_msg?: string | null;
    consent_enabled?: string | null;
    consent_id?: string | null;
    low_age_min?: string | null;
    low_age_max?: string | null;
    upper_age_min?: string | null;
    upper_age_max?: string | null;
    last_f2f_visit_months?: string | null;
  } | null> | null;
};

export type ServiceTypesQueryVariables = Exact<{
  input: ServiceTypesInput;
  appointmentTypesFilters?: InputMaybe<AppointmentTypesFilters>;
  serviceTypesFilters?: InputMaybe<ServiceTypesFilters>;
}>;

export type ServiceTypesQuery = {
  __typename?: 'Query';
  serviceTypes?: Array<{
    __typename?: 'ServiceType';
    id?: string | null;
    name?: string | null;
  } | null> | null;
};

export type AppointmentSlotsQueryVariables = Exact<{
  input: AppointmentSlotsInput;
}>;

export type AppointmentSlotsQuery = {
  __typename?: 'Query';
  appointmentSlots?: Array<{
    __typename?: 'AppointmentSlot';
    date?: string | null;
    appointments?: Array<{
      __typename?: 'Appointment';
      date?: string | null;
      time?: string | null;
      duration?: string | null;
    } | null> | null;
  } | null> | null;
};

export type CalendarQueryVariables = Exact<{
  input: CalendarInput;
}>;

export type CalendarQuery = {
  __typename?: 'Query';
  calendar?: {
    __typename?: 'Calendar';
    calendar?: Array<string | null> | null;
    first_available?: {
      __typename?: 'Appointment';
      date?: string | null;
      time?: string | null;
      duration?: string | null;
    } | null;
  } | null;
};

export type UserQueryVariables = Exact<{
  input?: InputMaybe<UserInput>;
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    username?: any | null;
    phone_number?: string | null;
    email?: string | null;
    email_verified?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    dob?: string | null;
    gender?: string | null;
    created_at?: any | null;
    updated_at?: any | null;
    automed?: any | null;
    family_members?: any | null;
  } | null;
};

export type PatientQueryVariables = Exact<{
  input: PatientInput;
}>;

export type PatientQuery = {
  __typename?: 'Query';
  patient?: {
    __typename?: 'Patient';
    patient_id?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    gender?: string | null;
    contact_number?: string | null;
    is_new_pt?: string | null;
    last_seen_did?: string | null;
  } | null;
};

export type UpcomingAppointmentsQueryVariables = Exact<{
  input?: InputMaybe<UpcomingAppointmentsInput>;
}>;

export type UpcomingAppointmentsQuery = {
  __typename?: 'Query';
  upcomingAppointments?: Array<{
    __typename?: 'UpcomingAppointment';
    patient_id?: string | null;
    is_new_pt?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    dob?: string | null;
    phone_number?: string | null;
    gender?: string | null;
    clinic_group_crm?: string | null;
    user_fk?: string | null;
    location_id?: string | null;
    doctor_id?: string | null;
    date?: string | null;
    time?: string | null;
    account_type?: string | null;
    appointment_id?: string | null;
    appointment_type_name?: string | null;
    appointment_type_id?: string | null;
    appointment_code?: string | null;
    cancellation_period?: string | null;
    doctor_full_name?: string | null;
    location_display_name?: string | null;
    address?: string | null;
    suburb?: string | null;
    state?: string | null;
    postcode?: string | null;
    location_phone?: string | null;
    lat?: string | null;
    lng?: string | null;
    image?: string | null;
  } | null> | null;
};

export type RegisteredClinicsQueryVariables = Exact<{
  input?: InputMaybe<RegisteredClinicsInput>;
}>;

export type RegisteredClinicsQuery = {
  __typename?: 'Query';
  registeredClinics?: Array<{
    __typename?: 'Clinic';
    clinic_group_crm?: string | null;
    user_fk?: string | null;
    location_id?: string | null;
    centre_name?: string | null;
    location_display_name?: string | null;
    is_default_location?: string | null;
    address?: string | null;
    suburb?: string | null;
    state?: string | null;
    postcode?: string | null;
    location_phone?: string | null;
    location_email?: string | null;
    contact_person_fName?: string | null;
    contact_person_lName?: string | null;
    clinic_group?: string | null;
    pms?: string | null;
    future_appt_wks?: string | null;
    lat?: string | null;
    lng?: string | null;
    website?: string | null;
    google_review_url?: string | null;
    kiosk_serial_no?: string | null;
    clinic_notice?: string | null;
    confirm_app_info?: string | null;
    confirm_app_holiday_info?: string | null;
    icon?: string | null;
    mon_start_time?: string | null;
    mon_end_time?: string | null;
    tue_start_time?: string | null;
    tue_end_time?: string | null;
    wed_start_time?: string | null;
    wed_end_time?: string | null;
    thu_start_time?: string | null;
    thu_end_time?: string | null;
    fri_start_time?: string | null;
    fri_end_time?: string | null;
    sat_start_time?: string | null;
    sat_end_time?: string | null;
    sun_start_time?: string | null;
    sun_end_time?: string | null;
    ph_start_time?: string | null;
    ph_end_time?: string | null;
  } | null> | null;
};

export type ScriptRulesQueryVariables = Exact<{
  input: ScriptRulesInput;
}>;

export type ScriptRulesQuery = {
  __typename?: 'Query';
  scriptRules?: {
    __typename?: 'ScriptRules';
    enable_scripts?: string | null;
    script_payment_req?: string | null;
    script_msg?: string | null;
    script_confirm_msg?: string | null;
    script_apprv_msg?: string | null;
    script_decl_msg?: string | null;
    script_comp_msg?: string | null;
    scripts_mobile?: string | null;
    script_delivery_mthds?: Array<{
      __typename?: 'ScriptDeliveryMethods';
      enabled?: string | null;
      pms_schedule_id?: string | null;
      pms_desc_id?: string | null;
      fee?: string | null;
      delivery_desc?: string | null;
    } | null> | null;
  } | null;
};

export type ReferralRulesQueryVariables = Exact<{
  input: ReferralRulesInput;
}>;

export type ReferralRulesQuery = {
  __typename?: 'Query';
  referralRules?: {
    __typename?: 'ReferralRules';
    enable_referrals?: string | null;
    referral_payment_req?: string | null;
    referral_msg?: string | null;
    referral_confirm_msg?: string | null;
    referral_apprv_msg?: string | null;
    referral_decl_msg?: string | null;
    referral_comp_msg?: string | null;
    referrals_mobile?: string | null;
    referral_delivery_mthds?: Array<{
      __typename?: 'ReferralDeliveryMethods';
      enabled?: string | null;
      pms_schedule_id?: string | null;
      pms_desc_id?: string | null;
      fee?: string | null;
      delivery_desc?: string | null;
    } | null> | null;
  } | null;
};

export type RequestConsultMutationVariables = Exact<{
  input: RequestConsultInput;
}>;

export type RequestConsultMutation = {
  __typename?: 'Mutation';
  requestConsult?: {
    __typename?: 'RequestConsultPayload';
    appointment_id?: string | null;
  } | null;
};

export type CancelConsultMutationVariables = Exact<{
  input: CancelConsultInput;
}>;

export type CancelConsultMutation = {
  __typename?: 'Mutation';
  cancelConsult?: {
    __typename?: 'CancelConsultPayload';
    success: boolean;
  } | null;
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser?: { __typename?: 'CreateUserPayload'; success: boolean } | null;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: { __typename?: 'UpdateUserPayload'; success: boolean } | null;
};

export type DeleteUserMutationVariables = Exact<{
  input?: InputMaybe<DeleteUserInput>;
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser?: { __typename?: 'DeleteUserPayload'; success: boolean } | null;
};

export type UpdateUserConfirmMutationVariables = Exact<{
  input: UpdateUserConfirmInput;
}>;

export type UpdateUserConfirmMutation = {
  __typename?: 'Mutation';
  updateUserConfirm?: {
    __typename?: 'UpdateUserConfirmPayload';
    success: boolean;
  } | null;
};

export type RegisterUserToClinicMutationVariables = Exact<{
  input: RegisterUserToClinicInput;
}>;

export type RegisterUserToClinicMutation = {
  __typename?: 'Mutation';
  registerUserToClinic?: {
    __typename?: 'RegisterUserToClinicPayload';
    success: boolean;
    patient_id?: string | null;
  } | null;
};

export type RemoveClinicFromUserMutationVariables = Exact<{
  input: RemoveClinicFromUserInput;
}>;

export type RemoveClinicFromUserMutation = {
  __typename?: 'Mutation';
  removeClinicFromUser?: {
    __typename?: 'RemoveClinicFromUserPayload';
    success: boolean;
  } | null;
};

export type RemoveFamilyMemberFromUserMutationVariables = Exact<{
  input: RemoveFamilyMemberFromUserInput;
}>;

export type RemoveFamilyMemberFromUserMutation = {
  __typename?: 'Mutation';
  removeFamilyMemberFromUser?: {
    __typename?: 'RemoveFamilyMemberFromUserPayload';
    success: boolean;
  } | null;
};

export type AddFamilyMemberToUserMutationVariables = Exact<{
  input: AddFamilyMemberToUserInput;
}>;

export type AddFamilyMemberToUserMutation = {
  __typename?: 'Mutation';
  addFamilyMemberToUser?: {
    __typename?: 'AddFamilyMemberToUserPayload';
    success: boolean;
  } | null;
};

export type RegisterFamilyMemberToClinicMutationVariables = Exact<{
  input: RegisterFamilyMemberToClinicInput;
}>;

export type RegisterFamilyMemberToClinicMutation = {
  __typename?: 'Mutation';
  registerFamilyMemberToClinic?: {
    __typename?: 'RegisterFamilyMemberToClinicPayload';
    success: boolean;
    patient_id?: string | null;
  } | null;
};

export type SendFamilyMemberVerificationMutationVariables = Exact<{
  input: SendFamilyMemberVerificationInput;
}>;

export type SendFamilyMemberVerificationMutation = {
  __typename?: 'Mutation';
  sendFamilyMemberVerification?: {
    __typename?: 'SendFamilyMemberVerificationPayload';
    success: boolean;
  } | null;
};

export type CreateScriptMutationVariables = Exact<{
  input: CreateScriptInput;
}>;

export type CreateScriptMutation = {
  __typename?: 'Mutation';
  createScript?: {
    __typename?: 'CreateScriptPayload';
    success: boolean;
  } | null;
};

export type CreateReferralMutationVariables = Exact<{
  input: CreateReferralInput;
}>;

export type CreateReferralMutation = {
  __typename?: 'Mutation';
  createReferral?: {
    __typename?: 'CreateReferralPayload';
    success: boolean;
  } | null;
};

export type CheckInMutationVariables = Exact<{
  input: CheckInInput;
}>;

export type CheckInMutation = {
  __typename?: 'Mutation';
  checkIn?: { __typename?: 'CheckInPayload'; success: boolean } | null;
};

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;

export type VerifyEmailMutation = {
  __typename?: 'Mutation';
  verifyEmail?: { __typename?: 'VerifyEmailPayload'; success: boolean } | null;
};

export type SendVerificationEmailMutationVariables = Exact<{
  input: SendVerificationEmailInput;
}>;

export type SendVerificationEmailMutation = {
  __typename?: 'Mutation';
  sendVerificationEmail?: {
    __typename?: 'SendVerificationEmailPayload';
    success: boolean;
  } | null;
};

export type SendAppFeedbackMutationVariables = Exact<{
  input: SendAppFeedbackInput;
}>;

export type SendAppFeedbackMutation = {
  __typename?: 'Mutation';
  sendAppFeedback?: {
    __typename?: 'SendAppFeedbackPayload';
    success: boolean;
  } | null;
};

export const ClinicFragmentDoc = gql`
  fragment Clinic on Clinic {
    clinic_group_crm
    user_fk
    location_id
    centre_name
    location_display_name
    is_default_location
    address
    suburb
    state
    postcode
    location_phone
    location_email
    contact_person_fName
    contact_person_lName
    clinic_group
    pms
    future_appt_wks
    lat
    lng
    website
    google_review_url
    kiosk_serial_no
    clinic_notice
    confirm_app_info
    confirm_app_holiday_info
    icon
    mon_start_time
    mon_end_time
    tue_start_time
    tue_end_time
    wed_start_time
    wed_end_time
    thu_start_time
    thu_end_time
    fri_start_time
    fri_end_time
    sat_start_time
    sat_end_time
    sun_start_time
    sun_end_time
    ph_start_time
    ph_end_time
  }
`;
export const DoctorFragmentDoc = gql`
  fragment Doctor on Doctor {
    clinic_group_crm
    user_fk
    doctor_id
    location_id
    display_name
    gender
    about
    appt_types
    appt_types_duration
    is_nurse_or_doc
    sort_order
    allow_online_app
    allow_walk_ins
    room_no
    no_new_patients
    my_patients
    display_only
    allow_scripts
    allow_referrals
    enable_doc_notice
    doc_notice
    in_isolation
    iso_date
    location_display_name
    first_name
    last_name
    image
  }
`;
export const AppointmentTypeFragmentDoc = gql`
  fragment AppointmentType on AppointmentType {
    clinic_group_crm
    user_fk
    location_id
    service_type_id
    appointment_type_id
    display_name
    standard_duration
    is_face_to_face
    start_time
    end_time
    nurse_required
    is_default
    cancellation_period
    question_required
    continue_or_no
    appt_que
    appt_inst
    new_patient
    week_days_only
    week_end_only
    pre_payment_req
    pre_payment_fees
    pre_payment_msg
    pre_payment_cnfrm_msg
    post_payment_req
    post_billing_type
    post_billing_fees
    post_billing_msg
    post_billing_cnfrm_msg
    consent_enabled
    consent_id
    low_age_min
    low_age_max
    upper_age_min
    upper_age_max
    last_f2f_visit_months
  }
`;
export const ServiceTypeFragmentDoc = gql`
  fragment ServiceType on ServiceType {
    id
    name
  }
`;
export const DoctorsAvailableFragmentDoc = gql`
  fragment DoctorsAvailable on DoctorsAvailable {
    doctor_id
    first_slot {
      date
      time
      duration
    }
  }
`;
export const BannedPatientsFragmentDoc = gql`
  fragment BannedPatients on BannedPatients {
    banned_level
    banned_msg
  }
`;
export const AppointmentFragmentDoc = gql`
  fragment Appointment on Appointment {
    date
    time
    duration
  }
`;
export const AppointmentSlotFragmentDoc = gql`
  fragment AppointmentSlot on AppointmentSlot {
    date
    appointments {
      ...Appointment
    }
  }
  ${AppointmentFragmentDoc}
`;
export const CalendarFragmentDoc = gql`
  fragment Calendar on Calendar {
    first_available {
      ...Appointment
    }
    calendar
  }
  ${AppointmentFragmentDoc}
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    username
    phone_number
    email
    email_verified
    first_name
    last_name
    dob
    gender
    created_at
    updated_at
    automed
    family_members
  }
`;
export const PatientFragmentDoc = gql`
  fragment Patient on Patient {
    patient_id
    first_name
    last_name
    gender
    contact_number
    is_new_pt
    last_seen_did
  }
`;
export const UpcomingAppointmentFragmentDoc = gql`
  fragment UpcomingAppointment on UpcomingAppointment {
    patient_id
    is_new_pt
    first_name
    last_name
    dob
    phone_number
    gender
    clinic_group_crm
    user_fk
    location_id
    doctor_id
    date
    time
    account_type
    appointment_id
    appointment_type_name
    appointment_type_id
    appointment_code
    cancellation_period
    doctor_full_name
    location_display_name
    address
    suburb
    state
    postcode
    location_phone
    lat
    lng
    image
  }
`;
export const ScriptRulesFragmentDoc = gql`
  fragment ScriptRules on ScriptRules {
    enable_scripts
    script_payment_req
    script_msg
    script_confirm_msg
    script_apprv_msg
    script_decl_msg
    script_comp_msg
    script_delivery_mthds {
      enabled
      pms_schedule_id
      pms_desc_id
      fee
      delivery_desc
    }
    scripts_mobile
  }
`;
export const ReferralRulesFragmentDoc = gql`
  fragment ReferralRules on ReferralRules {
    enable_referrals
    referral_payment_req
    referral_msg
    referral_confirm_msg
    referral_apprv_msg
    referral_decl_msg
    referral_comp_msg
    referral_delivery_mthds {
      enabled
      pms_schedule_id
      pms_desc_id
      fee
      delivery_desc
    }
    referrals_mobile
  }
`;
export const ClinicsDocument = gql`
  query Clinics($input: ClinicsInput!, $filters: ClinicsFilters) {
    clinics(input: $input, filters: $filters) {
      ...Clinic
    }
  }
  ${ClinicFragmentDoc}
`;

/**
 * __useClinicsQuery__
 *
 * To run a query within a React component, call `useClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useClinicsQuery(
  baseOptions: Apollo.QueryHookOptions<ClinicsQuery, ClinicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClinicsQuery, ClinicsQueryVariables>(
    ClinicsDocument,
    options
  );
}
export function useClinicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ClinicsQuery, ClinicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClinicsQuery, ClinicsQueryVariables>(
    ClinicsDocument,
    options
  );
}
export type ClinicsQueryHookResult = ReturnType<typeof useClinicsQuery>;
export type ClinicsLazyQueryHookResult = ReturnType<typeof useClinicsLazyQuery>;
export type ClinicsQueryResult = Apollo.QueryResult<
  ClinicsQuery,
  ClinicsQueryVariables
>;
export const DoctorsDocument = gql`
  query Doctors($input: DoctorsInput!, $filters: DoctorsFilters) {
    doctors(input: $input, filters: $filters) {
      ...Doctor
    }
  }
  ${DoctorFragmentDoc}
`;

/**
 * __useDoctorsQuery__
 *
 * To run a query within a React component, call `useDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDoctorsQuery(
  baseOptions: Apollo.QueryHookOptions<DoctorsQuery, DoctorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DoctorsQuery, DoctorsQueryVariables>(
    DoctorsDocument,
    options
  );
}
export function useDoctorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DoctorsQuery, DoctorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DoctorsQuery, DoctorsQueryVariables>(
    DoctorsDocument,
    options
  );
}
export type DoctorsQueryHookResult = ReturnType<typeof useDoctorsQuery>;
export type DoctorsLazyQueryHookResult = ReturnType<typeof useDoctorsLazyQuery>;
export type DoctorsQueryResult = Apollo.QueryResult<
  DoctorsQuery,
  DoctorsQueryVariables
>;
export const DoctorsAvailableDocument = gql`
  query DoctorsAvailable($input: DoctorsAvailableInput!) {
    doctorsAvailable(input: $input) {
      ...DoctorsAvailable
    }
  }
  ${DoctorsAvailableFragmentDoc}
`;

/**
 * __useDoctorsAvailableQuery__
 *
 * To run a query within a React component, call `useDoctorsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsAvailableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorsAvailableQuery(
  baseOptions: Apollo.QueryHookOptions<
    DoctorsAvailableQuery,
    DoctorsAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DoctorsAvailableQuery, DoctorsAvailableQueryVariables>(
    DoctorsAvailableDocument,
    options
  );
}
export function useDoctorsAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoctorsAvailableQuery,
    DoctorsAvailableQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DoctorsAvailableQuery,
    DoctorsAvailableQueryVariables
  >(DoctorsAvailableDocument, options);
}
export type DoctorsAvailableQueryHookResult = ReturnType<
  typeof useDoctorsAvailableQuery
>;
export type DoctorsAvailableLazyQueryHookResult = ReturnType<
  typeof useDoctorsAvailableLazyQuery
>;
export type DoctorsAvailableQueryResult = Apollo.QueryResult<
  DoctorsAvailableQuery,
  DoctorsAvailableQueryVariables
>;
export const BannedPatientsDocument = gql`
  query BannedPatients($input: BannedPatientsInput!) {
    bannedPatients(input: $input) {
      ...BannedPatients
    }
  }
  ${BannedPatientsFragmentDoc}
`;

/**
 * __useBannedPatientsQuery__
 *
 * To run a query within a React component, call `useBannedPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannedPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannedPatientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBannedPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    BannedPatientsQuery,
    BannedPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BannedPatientsQuery, BannedPatientsQueryVariables>(
    BannedPatientsDocument,
    options
  );
}
export function useBannedPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BannedPatientsQuery,
    BannedPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BannedPatientsQuery, BannedPatientsQueryVariables>(
    BannedPatientsDocument,
    options
  );
}
export type BannedPatientsQueryHookResult = ReturnType<
  typeof useBannedPatientsQuery
>;
export type BannedPatientsLazyQueryHookResult = ReturnType<
  typeof useBannedPatientsLazyQuery
>;
export type BannedPatientsQueryResult = Apollo.QueryResult<
  BannedPatientsQuery,
  BannedPatientsQueryVariables
>;
export const AppointmentTypesDocument = gql`
  query AppointmentTypes(
    $input: AppointmentTypesInput!
    $filters: AppointmentTypesFilters
  ) {
    appointmentTypes(input: $input, filters: $filters) {
      ...AppointmentType
    }
  }
  ${AppointmentTypeFragmentDoc}
`;

/**
 * __useAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAppointmentTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppointmentTypesQuery,
    AppointmentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppointmentTypesQuery, AppointmentTypesQueryVariables>(
    AppointmentTypesDocument,
    options
  );
}
export function useAppointmentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppointmentTypesQuery,
    AppointmentTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppointmentTypesQuery,
    AppointmentTypesQueryVariables
  >(AppointmentTypesDocument, options);
}
export type AppointmentTypesQueryHookResult = ReturnType<
  typeof useAppointmentTypesQuery
>;
export type AppointmentTypesLazyQueryHookResult = ReturnType<
  typeof useAppointmentTypesLazyQuery
>;
export type AppointmentTypesQueryResult = Apollo.QueryResult<
  AppointmentTypesQuery,
  AppointmentTypesQueryVariables
>;
export const ServiceTypesDocument = gql`
  query ServiceTypes(
    $input: ServiceTypesInput!
    $appointmentTypesFilters: AppointmentTypesFilters
    $serviceTypesFilters: ServiceTypesFilters
  ) {
    serviceTypes(
      input: $input
      appointmentTypesFilters: $appointmentTypesFilters
      serviceTypesFilters: $serviceTypesFilters
    ) {
      ...ServiceType
    }
  }
  ${ServiceTypeFragmentDoc}
`;

/**
 * __useServiceTypesQuery__
 *
 * To run a query within a React component, call `useServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      appointmentTypesFilters: // value for 'appointmentTypesFilters'
 *      serviceTypesFilters: // value for 'serviceTypesFilters'
 *   },
 * });
 */
export function useServiceTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServiceTypesQuery, ServiceTypesQueryVariables>(
    ServiceTypesDocument,
    options
  );
}
export function useServiceTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServiceTypesQuery, ServiceTypesQueryVariables>(
    ServiceTypesDocument,
    options
  );
}
export type ServiceTypesQueryHookResult = ReturnType<
  typeof useServiceTypesQuery
>;
export type ServiceTypesLazyQueryHookResult = ReturnType<
  typeof useServiceTypesLazyQuery
>;
export type ServiceTypesQueryResult = Apollo.QueryResult<
  ServiceTypesQuery,
  ServiceTypesQueryVariables
>;
export const AppointmentSlotsDocument = gql`
  query AppointmentSlots($input: AppointmentSlotsInput!) {
    appointmentSlots(input: $input) {
      ...AppointmentSlot
    }
  }
  ${AppointmentSlotFragmentDoc}
`;

/**
 * __useAppointmentSlotsQuery__
 *
 * To run a query within a React component, call `useAppointmentSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentSlotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppointmentSlotsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppointmentSlotsQuery,
    AppointmentSlotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppointmentSlotsQuery, AppointmentSlotsQueryVariables>(
    AppointmentSlotsDocument,
    options
  );
}
export function useAppointmentSlotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppointmentSlotsQuery,
    AppointmentSlotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppointmentSlotsQuery,
    AppointmentSlotsQueryVariables
  >(AppointmentSlotsDocument, options);
}
export type AppointmentSlotsQueryHookResult = ReturnType<
  typeof useAppointmentSlotsQuery
>;
export type AppointmentSlotsLazyQueryHookResult = ReturnType<
  typeof useAppointmentSlotsLazyQuery
>;
export type AppointmentSlotsQueryResult = Apollo.QueryResult<
  AppointmentSlotsQuery,
  AppointmentSlotsQueryVariables
>;
export const CalendarDocument = gql`
  query Calendar($input: CalendarInput!) {
    calendar(input: $input) {
      ...Calendar
    }
  }
  ${CalendarFragmentDoc}
`;

/**
 * __useCalendarQuery__
 *
 * To run a query within a React component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<CalendarQuery, CalendarQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalendarQuery, CalendarQueryVariables>(
    CalendarDocument,
    options
  );
}
export function useCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalendarQuery,
    CalendarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CalendarQuery, CalendarQueryVariables>(
    CalendarDocument,
    options
  );
}
export type CalendarQueryHookResult = ReturnType<typeof useCalendarQuery>;
export type CalendarLazyQueryHookResult = ReturnType<
  typeof useCalendarLazyQuery
>;
export type CalendarQueryResult = Apollo.QueryResult<
  CalendarQuery,
  CalendarQueryVariables
>;
export const UserDocument = gql`
  query User($input: UserInput) {
    user(input: $input) {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options
  );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const PatientDocument = gql`
  query Patient($input: PatientInput!) {
    patient(input: $input) {
      ...Patient
    }
  }
  ${PatientFragmentDoc}
`;

/**
 * __usePatientQuery__
 *
 * To run a query within a React component, call `usePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientQuery(
  baseOptions: Apollo.QueryHookOptions<PatientQuery, PatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PatientQuery, PatientQueryVariables>(
    PatientDocument,
    options
  );
}
export function usePatientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PatientQuery, PatientQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PatientQuery, PatientQueryVariables>(
    PatientDocument,
    options
  );
}
export type PatientQueryHookResult = ReturnType<typeof usePatientQuery>;
export type PatientLazyQueryHookResult = ReturnType<typeof usePatientLazyQuery>;
export type PatientQueryResult = Apollo.QueryResult<
  PatientQuery,
  PatientQueryVariables
>;
export const UpcomingAppointmentsDocument = gql`
  query UpcomingAppointments($input: UpcomingAppointmentsInput) {
    upcomingAppointments(input: $input) {
      ...UpcomingAppointment
    }
  }
  ${UpcomingAppointmentFragmentDoc}
`;

/**
 * __useUpcomingAppointmentsQuery__
 *
 * To run a query within a React component, call `useUpcomingAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpcomingAppointmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UpcomingAppointmentsQuery,
    UpcomingAppointmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpcomingAppointmentsQuery,
    UpcomingAppointmentsQueryVariables
  >(UpcomingAppointmentsDocument, options);
}
export function useUpcomingAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpcomingAppointmentsQuery,
    UpcomingAppointmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpcomingAppointmentsQuery,
    UpcomingAppointmentsQueryVariables
  >(UpcomingAppointmentsDocument, options);
}
export type UpcomingAppointmentsQueryHookResult = ReturnType<
  typeof useUpcomingAppointmentsQuery
>;
export type UpcomingAppointmentsLazyQueryHookResult = ReturnType<
  typeof useUpcomingAppointmentsLazyQuery
>;
export type UpcomingAppointmentsQueryResult = Apollo.QueryResult<
  UpcomingAppointmentsQuery,
  UpcomingAppointmentsQueryVariables
>;
export const RegisteredClinicsDocument = gql`
  query RegisteredClinics($input: RegisteredClinicsInput) {
    registeredClinics(input: $input) {
      ...Clinic
    }
  }
  ${ClinicFragmentDoc}
`;

/**
 * __useRegisteredClinicsQuery__
 *
 * To run a query within a React component, call `useRegisteredClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredClinicsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisteredClinicsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RegisteredClinicsQuery,
    RegisteredClinicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RegisteredClinicsQuery,
    RegisteredClinicsQueryVariables
  >(RegisteredClinicsDocument, options);
}
export function useRegisteredClinicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisteredClinicsQuery,
    RegisteredClinicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisteredClinicsQuery,
    RegisteredClinicsQueryVariables
  >(RegisteredClinicsDocument, options);
}
export type RegisteredClinicsQueryHookResult = ReturnType<
  typeof useRegisteredClinicsQuery
>;
export type RegisteredClinicsLazyQueryHookResult = ReturnType<
  typeof useRegisteredClinicsLazyQuery
>;
export type RegisteredClinicsQueryResult = Apollo.QueryResult<
  RegisteredClinicsQuery,
  RegisteredClinicsQueryVariables
>;
export const ScriptRulesDocument = gql`
  query ScriptRules($input: ScriptRulesInput!) {
    scriptRules(input: $input) {
      ...ScriptRules
    }
  }
  ${ScriptRulesFragmentDoc}
`;

/**
 * __useScriptRulesQuery__
 *
 * To run a query within a React component, call `useScriptRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScriptRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScriptRulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScriptRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScriptRulesQuery,
    ScriptRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ScriptRulesQuery, ScriptRulesQueryVariables>(
    ScriptRulesDocument,
    options
  );
}
export function useScriptRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScriptRulesQuery,
    ScriptRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ScriptRulesQuery, ScriptRulesQueryVariables>(
    ScriptRulesDocument,
    options
  );
}
export type ScriptRulesQueryHookResult = ReturnType<typeof useScriptRulesQuery>;
export type ScriptRulesLazyQueryHookResult = ReturnType<
  typeof useScriptRulesLazyQuery
>;
export type ScriptRulesQueryResult = Apollo.QueryResult<
  ScriptRulesQuery,
  ScriptRulesQueryVariables
>;
export const ReferralRulesDocument = gql`
  query ReferralRules($input: ReferralRulesInput!) {
    referralRules(input: $input) {
      ...ReferralRules
    }
  }
  ${ReferralRulesFragmentDoc}
`;

/**
 * __useReferralRulesQuery__
 *
 * To run a query within a React component, call `useReferralRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralRulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferralRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReferralRulesQuery,
    ReferralRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReferralRulesQuery, ReferralRulesQueryVariables>(
    ReferralRulesDocument,
    options
  );
}
export function useReferralRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferralRulesQuery,
    ReferralRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReferralRulesQuery, ReferralRulesQueryVariables>(
    ReferralRulesDocument,
    options
  );
}
export type ReferralRulesQueryHookResult = ReturnType<
  typeof useReferralRulesQuery
>;
export type ReferralRulesLazyQueryHookResult = ReturnType<
  typeof useReferralRulesLazyQuery
>;
export type ReferralRulesQueryResult = Apollo.QueryResult<
  ReferralRulesQuery,
  ReferralRulesQueryVariables
>;
export const RequestConsultDocument = gql`
  mutation RequestConsult($input: RequestConsultInput!) {
    requestConsult(input: $input) {
      appointment_id
    }
  }
`;
export type RequestConsultMutationFn = Apollo.MutationFunction<
  RequestConsultMutation,
  RequestConsultMutationVariables
>;

/**
 * __useRequestConsultMutation__
 *
 * To run a mutation, you first call `useRequestConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestConsultMutation, { data, loading, error }] = useRequestConsultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestConsultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestConsultMutation,
    RequestConsultMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestConsultMutation,
    RequestConsultMutationVariables
  >(RequestConsultDocument, options);
}
export type RequestConsultMutationHookResult = ReturnType<
  typeof useRequestConsultMutation
>;
export type RequestConsultMutationResult =
  Apollo.MutationResult<RequestConsultMutation>;
export type RequestConsultMutationOptions = Apollo.BaseMutationOptions<
  RequestConsultMutation,
  RequestConsultMutationVariables
>;
export const CancelConsultDocument = gql`
  mutation CancelConsult($input: CancelConsultInput!) {
    cancelConsult(input: $input) {
      success
    }
  }
`;
export type CancelConsultMutationFn = Apollo.MutationFunction<
  CancelConsultMutation,
  CancelConsultMutationVariables
>;

/**
 * __useCancelConsultMutation__
 *
 * To run a mutation, you first call `useCancelConsultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelConsultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelConsultMutation, { data, loading, error }] = useCancelConsultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelConsultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelConsultMutation,
    CancelConsultMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelConsultMutation,
    CancelConsultMutationVariables
  >(CancelConsultDocument, options);
}
export type CancelConsultMutationHookResult = ReturnType<
  typeof useCancelConsultMutation
>;
export type CancelConsultMutationResult =
  Apollo.MutationResult<CancelConsultMutation>;
export type CancelConsultMutationOptions = Apollo.BaseMutationOptions<
  CancelConsultMutation,
  CancelConsultMutationVariables
>;
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      success
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMutation,
    CreateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult =
  Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      success
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($input: DeleteUserInput) {
    deleteUser(input: $input) {
      success
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult =
  Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const UpdateUserConfirmDocument = gql`
  mutation UpdateUserConfirm($input: UpdateUserConfirmInput!) {
    updateUserConfirm(input: $input) {
      success
    }
  }
`;
export type UpdateUserConfirmMutationFn = Apollo.MutationFunction<
  UpdateUserConfirmMutation,
  UpdateUserConfirmMutationVariables
>;

/**
 * __useUpdateUserConfirmMutation__
 *
 * To run a mutation, you first call `useUpdateUserConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserConfirmMutation, { data, loading, error }] = useUpdateUserConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserConfirmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserConfirmMutation,
    UpdateUserConfirmMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserConfirmMutation,
    UpdateUserConfirmMutationVariables
  >(UpdateUserConfirmDocument, options);
}
export type UpdateUserConfirmMutationHookResult = ReturnType<
  typeof useUpdateUserConfirmMutation
>;
export type UpdateUserConfirmMutationResult =
  Apollo.MutationResult<UpdateUserConfirmMutation>;
export type UpdateUserConfirmMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserConfirmMutation,
  UpdateUserConfirmMutationVariables
>;
export const RegisterUserToClinicDocument = gql`
  mutation RegisterUserToClinic($input: RegisterUserToClinicInput!) {
    registerUserToClinic(input: $input) {
      success
      patient_id
    }
  }
`;
export type RegisterUserToClinicMutationFn = Apollo.MutationFunction<
  RegisterUserToClinicMutation,
  RegisterUserToClinicMutationVariables
>;

/**
 * __useRegisterUserToClinicMutation__
 *
 * To run a mutation, you first call `useRegisterUserToClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserToClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserToClinicMutation, { data, loading, error }] = useRegisterUserToClinicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserToClinicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterUserToClinicMutation,
    RegisterUserToClinicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterUserToClinicMutation,
    RegisterUserToClinicMutationVariables
  >(RegisterUserToClinicDocument, options);
}
export type RegisterUserToClinicMutationHookResult = ReturnType<
  typeof useRegisterUserToClinicMutation
>;
export type RegisterUserToClinicMutationResult =
  Apollo.MutationResult<RegisterUserToClinicMutation>;
export type RegisterUserToClinicMutationOptions = Apollo.BaseMutationOptions<
  RegisterUserToClinicMutation,
  RegisterUserToClinicMutationVariables
>;
export const RemoveClinicFromUserDocument = gql`
  mutation RemoveClinicFromUser($input: RemoveClinicFromUserInput!) {
    removeClinicFromUser(input: $input) {
      success
    }
  }
`;
export type RemoveClinicFromUserMutationFn = Apollo.MutationFunction<
  RemoveClinicFromUserMutation,
  RemoveClinicFromUserMutationVariables
>;

/**
 * __useRemoveClinicFromUserMutation__
 *
 * To run a mutation, you first call `useRemoveClinicFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClinicFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClinicFromUserMutation, { data, loading, error }] = useRemoveClinicFromUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveClinicFromUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveClinicFromUserMutation,
    RemoveClinicFromUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveClinicFromUserMutation,
    RemoveClinicFromUserMutationVariables
  >(RemoveClinicFromUserDocument, options);
}
export type RemoveClinicFromUserMutationHookResult = ReturnType<
  typeof useRemoveClinicFromUserMutation
>;
export type RemoveClinicFromUserMutationResult =
  Apollo.MutationResult<RemoveClinicFromUserMutation>;
export type RemoveClinicFromUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveClinicFromUserMutation,
  RemoveClinicFromUserMutationVariables
>;
export const RemoveFamilyMemberFromUserDocument = gql`
  mutation RemoveFamilyMemberFromUser(
    $input: RemoveFamilyMemberFromUserInput!
  ) {
    removeFamilyMemberFromUser(input: $input) {
      success
    }
  }
`;
export type RemoveFamilyMemberFromUserMutationFn = Apollo.MutationFunction<
  RemoveFamilyMemberFromUserMutation,
  RemoveFamilyMemberFromUserMutationVariables
>;

/**
 * __useRemoveFamilyMemberFromUserMutation__
 *
 * To run a mutation, you first call `useRemoveFamilyMemberFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFamilyMemberFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFamilyMemberFromUserMutation, { data, loading, error }] = useRemoveFamilyMemberFromUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFamilyMemberFromUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveFamilyMemberFromUserMutation,
    RemoveFamilyMemberFromUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveFamilyMemberFromUserMutation,
    RemoveFamilyMemberFromUserMutationVariables
  >(RemoveFamilyMemberFromUserDocument, options);
}
export type RemoveFamilyMemberFromUserMutationHookResult = ReturnType<
  typeof useRemoveFamilyMemberFromUserMutation
>;
export type RemoveFamilyMemberFromUserMutationResult =
  Apollo.MutationResult<RemoveFamilyMemberFromUserMutation>;
export type RemoveFamilyMemberFromUserMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveFamilyMemberFromUserMutation,
    RemoveFamilyMemberFromUserMutationVariables
  >;
export const AddFamilyMemberToUserDocument = gql`
  mutation AddFamilyMemberToUser($input: AddFamilyMemberToUserInput!) {
    addFamilyMemberToUser(input: $input) {
      success
    }
  }
`;
export type AddFamilyMemberToUserMutationFn = Apollo.MutationFunction<
  AddFamilyMemberToUserMutation,
  AddFamilyMemberToUserMutationVariables
>;

/**
 * __useAddFamilyMemberToUserMutation__
 *
 * To run a mutation, you first call `useAddFamilyMemberToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFamilyMemberToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFamilyMemberToUserMutation, { data, loading, error }] = useAddFamilyMemberToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFamilyMemberToUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddFamilyMemberToUserMutation,
    AddFamilyMemberToUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddFamilyMemberToUserMutation,
    AddFamilyMemberToUserMutationVariables
  >(AddFamilyMemberToUserDocument, options);
}
export type AddFamilyMemberToUserMutationHookResult = ReturnType<
  typeof useAddFamilyMemberToUserMutation
>;
export type AddFamilyMemberToUserMutationResult =
  Apollo.MutationResult<AddFamilyMemberToUserMutation>;
export type AddFamilyMemberToUserMutationOptions = Apollo.BaseMutationOptions<
  AddFamilyMemberToUserMutation,
  AddFamilyMemberToUserMutationVariables
>;
export const RegisterFamilyMemberToClinicDocument = gql`
  mutation RegisterFamilyMemberToClinic(
    $input: RegisterFamilyMemberToClinicInput!
  ) {
    registerFamilyMemberToClinic(input: $input) {
      success
      patient_id
    }
  }
`;
export type RegisterFamilyMemberToClinicMutationFn = Apollo.MutationFunction<
  RegisterFamilyMemberToClinicMutation,
  RegisterFamilyMemberToClinicMutationVariables
>;

/**
 * __useRegisterFamilyMemberToClinicMutation__
 *
 * To run a mutation, you first call `useRegisterFamilyMemberToClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterFamilyMemberToClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerFamilyMemberToClinicMutation, { data, loading, error }] = useRegisterFamilyMemberToClinicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterFamilyMemberToClinicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterFamilyMemberToClinicMutation,
    RegisterFamilyMemberToClinicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterFamilyMemberToClinicMutation,
    RegisterFamilyMemberToClinicMutationVariables
  >(RegisterFamilyMemberToClinicDocument, options);
}
export type RegisterFamilyMemberToClinicMutationHookResult = ReturnType<
  typeof useRegisterFamilyMemberToClinicMutation
>;
export type RegisterFamilyMemberToClinicMutationResult =
  Apollo.MutationResult<RegisterFamilyMemberToClinicMutation>;
export type RegisterFamilyMemberToClinicMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterFamilyMemberToClinicMutation,
    RegisterFamilyMemberToClinicMutationVariables
  >;
export const SendFamilyMemberVerificationDocument = gql`
  mutation SendFamilyMemberVerification(
    $input: SendFamilyMemberVerificationInput!
  ) {
    sendFamilyMemberVerification(input: $input) {
      success
    }
  }
`;
export type SendFamilyMemberVerificationMutationFn = Apollo.MutationFunction<
  SendFamilyMemberVerificationMutation,
  SendFamilyMemberVerificationMutationVariables
>;

/**
 * __useSendFamilyMemberVerificationMutation__
 *
 * To run a mutation, you first call `useSendFamilyMemberVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFamilyMemberVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFamilyMemberVerificationMutation, { data, loading, error }] = useSendFamilyMemberVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFamilyMemberVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendFamilyMemberVerificationMutation,
    SendFamilyMemberVerificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendFamilyMemberVerificationMutation,
    SendFamilyMemberVerificationMutationVariables
  >(SendFamilyMemberVerificationDocument, options);
}
export type SendFamilyMemberVerificationMutationHookResult = ReturnType<
  typeof useSendFamilyMemberVerificationMutation
>;
export type SendFamilyMemberVerificationMutationResult =
  Apollo.MutationResult<SendFamilyMemberVerificationMutation>;
export type SendFamilyMemberVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    SendFamilyMemberVerificationMutation,
    SendFamilyMemberVerificationMutationVariables
  >;
export const CreateScriptDocument = gql`
  mutation CreateScript($input: CreateScriptInput!) {
    createScript(input: $input) {
      success
    }
  }
`;
export type CreateScriptMutationFn = Apollo.MutationFunction<
  CreateScriptMutation,
  CreateScriptMutationVariables
>;

/**
 * __useCreateScriptMutation__
 *
 * To run a mutation, you first call `useCreateScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScriptMutation, { data, loading, error }] = useCreateScriptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScriptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScriptMutation,
    CreateScriptMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScriptMutation,
    CreateScriptMutationVariables
  >(CreateScriptDocument, options);
}
export type CreateScriptMutationHookResult = ReturnType<
  typeof useCreateScriptMutation
>;
export type CreateScriptMutationResult =
  Apollo.MutationResult<CreateScriptMutation>;
export type CreateScriptMutationOptions = Apollo.BaseMutationOptions<
  CreateScriptMutation,
  CreateScriptMutationVariables
>;
export const CreateReferralDocument = gql`
  mutation CreateReferral($input: CreateReferralInput!) {
    createReferral(input: $input) {
      success
    }
  }
`;
export type CreateReferralMutationFn = Apollo.MutationFunction<
  CreateReferralMutation,
  CreateReferralMutationVariables
>;

/**
 * __useCreateReferralMutation__
 *
 * To run a mutation, you first call `useCreateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferralMutation, { data, loading, error }] = useCreateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReferralMutation,
    CreateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReferralMutation,
    CreateReferralMutationVariables
  >(CreateReferralDocument, options);
}
export type CreateReferralMutationHookResult = ReturnType<
  typeof useCreateReferralMutation
>;
export type CreateReferralMutationResult =
  Apollo.MutationResult<CreateReferralMutation>;
export type CreateReferralMutationOptions = Apollo.BaseMutationOptions<
  CreateReferralMutation,
  CreateReferralMutationVariables
>;
export const CheckInDocument = gql`
  mutation CheckIn($input: CheckInInput!) {
    checkIn(input: $input) {
      success
    }
  }
`;
export type CheckInMutationFn = Apollo.MutationFunction<
  CheckInMutation,
  CheckInMutationVariables
>;

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckInMutation,
    CheckInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(
    CheckInDocument,
    options
  );
}
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>;
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>;
export type CheckInMutationOptions = Apollo.BaseMutationOptions<
  CheckInMutation,
  CheckInMutationVariables
>;
export const VerifyEmailDocument = gql`
  mutation VerifyEmail($input: VerifyEmailInput!) {
    verifyEmail(input: $input) {
      success
    }
  }
`;
export type VerifyEmailMutationFn = Apollo.MutationFunction<
  VerifyEmailMutation,
  VerifyEmailMutationVariables
>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailMutation,
    VerifyEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(
    VerifyEmailDocument,
    options
  );
}
export type VerifyEmailMutationHookResult = ReturnType<
  typeof useVerifyEmailMutation
>;
export type VerifyEmailMutationResult =
  Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailMutation,
  VerifyEmailMutationVariables
>;
export const SendVerificationEmailDocument = gql`
  mutation SendVerificationEmail($input: SendVerificationEmailInput!) {
    sendVerificationEmail(input: $input) {
      success
    }
  }
`;
export type SendVerificationEmailMutationFn = Apollo.MutationFunction<
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables
>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVerificationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >(SendVerificationEmailDocument, options);
}
export type SendVerificationEmailMutationHookResult = ReturnType<
  typeof useSendVerificationEmailMutation
>;
export type SendVerificationEmailMutationResult =
  Apollo.MutationResult<SendVerificationEmailMutation>;
export type SendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables
>;
export const SendAppFeedbackDocument = gql`
  mutation SendAppFeedback($input: SendAppFeedbackInput!) {
    sendAppFeedback(input: $input) {
      success
    }
  }
`;
export type SendAppFeedbackMutationFn = Apollo.MutationFunction<
  SendAppFeedbackMutation,
  SendAppFeedbackMutationVariables
>;

/**
 * __useSendAppFeedbackMutation__
 *
 * To run a mutation, you first call `useSendAppFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAppFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAppFeedbackMutation, { data, loading, error }] = useSendAppFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAppFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendAppFeedbackMutation,
    SendAppFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendAppFeedbackMutation,
    SendAppFeedbackMutationVariables
  >(SendAppFeedbackDocument, options);
}
export type SendAppFeedbackMutationHookResult = ReturnType<
  typeof useSendAppFeedbackMutation
>;
export type SendAppFeedbackMutationResult =
  Apollo.MutationResult<SendAppFeedbackMutation>;
export type SendAppFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SendAppFeedbackMutation,
  SendAppFeedbackMutationVariables
>;
